import { Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FeatherIconNames} from 'feather-icons';
import {FeatherPipe} from '../../../core/pipes/feather.pipe';

@Component({
  selector: 'app-accordion-item',
  standalone: true,
  imports: [CommonModule, FeatherPipe],
  templateUrl: './accordion-item.component.html',
  styleUrls: ['./accordion-item.component.scss']
})
export class AccordionItemComponent {
  @Input({ required: true }) id!: string;
  @Input({ required: true }) label!: string;
  @Input() disabled = false;
  // Fallback icon name/class similar to app-button feather usage: allow string name
  @Input() icon?: FeatherIconNames | null;
  // Allow consumer to pass extra Tailwind classes
  @Input() headerClass = '';
  @Input() bodyClass = '';

  // Controlled by parent AccordionComponent
  @Input() visible = false;

  toggle(): void {
    if (this.disabled) return;
    this.visible = !this.visible;
  }
}
